import { FetchResult } from '@apollo/client'
import { client } from '../../..'
import { RescheduleMeetingMutation, RescheduleMeetingInput, RescheduleMeetingMutationVariables } from '../../../types'
import { MEETINGS_BY_MANAGER } from '../meeting.graphql'
import { RESCHEDULE_MEETING } from '../MeetingMutations'

export default (
  reviewerId: number,
): {
  rescheduleMeeting: (rescheduleInput: RescheduleMeetingInput) => Promise<FetchResult<RescheduleMeetingMutation>>
} => {
  const rescheduleMeeting = async (rescheduleInput: RescheduleMeetingInput): Promise<FetchResult<RescheduleMeetingMutation>> => {
    return await client.mutate<RescheduleMeetingMutation, RescheduleMeetingMutationVariables>({
      mutation: RESCHEDULE_MEETING,
      variables: {
        rescheduleInput,
      },
      refetchQueries: [
        {
          query: MEETINGS_BY_MANAGER,
          variables: { managerId: reviewerId },
        },
      ],
      awaitRefetchQueries: true,
    })
  }

  return { rescheduleMeeting }
}
